import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "col batch-discount-option__container" }
const _hoisted_3 = ["id", "checked"]
const _hoisted_4 = { class: "batch-discount-option__label" }
const _hoisted_5 = { class: "batch-discount-option__sub-label" }

import { PropType, ref } from "vue";
import { IQuantityBreak } from "@/models/IQuantityBreak";
import { Uuid } from "@/code/Uuid";
import { PriceExtensions } from "@/code/PriceExtensions";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCartQuantityOption',
  props: {
  quantityBreak: {
    type: Object as PropType<IQuantityBreak>,
    required: true,
  },
  isChecked: {
    type: Boolean,
    required: true,
  },
  unitOfMeasurement: {
    type: String,
    required: true,
  },
},
  emits: {
  click: (quantityBreak: IQuantityBreak) => true,
},
  setup(__props, { emit }) {

const props = __props;



const inputId = ref(Uuid.newUuid());
const onClick = () => {
  emit("click", props.quantityBreak);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["row align-items-center g-0 batch-discount-option", { 'batch-discount-option--checked': __props.isChecked }]),
    for: inputId.value
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        id: inputId.value,
        class: "batch-discount-option__input",
        type: "radio",
        value: "",
        onChange: onClick,
        checked: __props.isChecked
      }, null, 40, _hoisted_3),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.quantityBreak.qtyBreak) + " " + _toDisplayString(__props.unitOfMeasurement), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(PriceExtensions).getPriceFormattedByCustomerType(
            __props.quantityBreak.valueIncVatFormatted,
            __props.quantityBreak.valueFormatted
          )) + " pr. " + _toDisplayString(__props.unitOfMeasurement), 1)
    ])
  ], 10, _hoisted_1))
}
}

})